// extracted by css-extract-rspack-plugin
module.exports =  {"root":"fbe1794b0a","title":"c352096144","subtitle":"af986856ca","fact":"e618d80bf4","children":"e139fe335b","wrapper":"bd5dacb7eb","button":"e9c63f202e"};